/*
 * spellingarea.js
 *
 * Prerequisites:
 * - jQuery
 * - jquery.highlight-within-textarea.js (alwaysdata version)
 *
 * How to:
 * $('#check-language-btn').checkSpelling("textarea_id", "check-language-info");
 */

(function($) {
    function createSuggestions(errors) {
        suggestions = [];
        var excludedRuleIds = ['FRENCH_WHITESPACE'];
        for (var i = 0; i < errors.length; i++) {
            var ruleId = errors[i].rule.id;
            if($.inArray(ruleId, excludedRuleIds) == -1) {
                var suggestion = {};
                suggestion["description"] = errors[i].message;
                suggestion["offset"] = parseInt(errors[i].offset);
                suggestion["errorlength"] = parseInt(errors[i].length);
                suggestions.push(suggestion);
            }
        }
        return suggestions;
    }
    function sendRequest(post_data, callback) {
        var postData = "language=fr&text=" + encodeURI(post_data).replace(/&/g, '%26').replace(/\+/g, '%2B');
        jQuery.ajax({
            url: "https://languagetool.org/api/v2/check",
            type: "POST",
            data: postData,
            success: function(data, textStatus, jqXHR) {
                suggestions = createSuggestions(data.matches);
                callback(suggestions);
            }
        });
    }
    $.fn.checkSpelling = function(area_id, info_id) {
        var area = $('#' + area_id);
        this.click(function() {
            sendRequest(area.val(), function(suggestions) {
                info_html = "<ul>";
                for (var j=0; j<suggestions.length; j++) {
                    var start = suggestions[j].offset;
                    var length = suggestions[j].errorlength;
                    info_html += "<li>" + area.val().substr(start, length) + " : " + suggestions[j].description + "</li>";
                }
                info_html += "</ul>";
                $('#' + info_id).html(info_html);
            });
        });
    };
})(jQuery);
